import { Button, Typography } from '@breetometer/components';
import { SettingsMenuIcon } from 'BreetAssets';

import { filterSideMenuItemPermissions, type IMobileSubMenus } from './SidebarMobile.helpers';

export const SubMenus = ({
	subMenus,
	dropdownRef,
	dropdownStyles,
	setMobileMenu,
	onMenuClick,
	hasAnyPermission,
	hasPermission,
	isKybPending,
	userData,
}: IMobileSubMenus) => (
	<div
		ref={dropdownRef}
		style={dropdownStyles}
		className='dropdownsubmenu bg-primary-500 border-primary-500'
	>
		<Typography
			as='ul'
			className='dropdownsubmenu_content scrollbar'
		>
			{subMenus?.filter(filterSideMenuItemPermissions(isKybPending, hasAnyPermission, hasPermission, userData)).map((item) => (
				<Typography
					as='li'
					className='dropdownsubmenu_menuitem'
					key={item.menu}
				>
					<Button
						variant='native'
						onClick={setMobileMenu(onMenuClick(item.url, item.external))}
						className='color-neutral-50'
					>
						<SettingsMenuIcon
							variant={item.icon}
							className='appsettings_menuicon svg-dark svg-dark-outline'
						/>
						{item.menu}
					</Button>
				</Typography>
			))}
		</Typography>
	</div>
);
